import React from 'react';
import { FormattedMessage } from 'react-intl';

class YouKassaComponent extends React.Component {
    intervalId = null; // Свойство для хранения ID интервала
    constructor(props) {
        super(props);
        this.state = {
          Result: "",
          topic: null,
          useragreement:""

        };

        this._isMounted = false;
      }


      getBrowserLanguage  () {
        //const language = navigator.language.split(/[-_]/)[0]; // Language without region code
        const language = this.props.intl.locale.split(/[-_]/)[0];
        return language ? language : 'en'; // Фолбэк на английский, если язык не поддерживается
      };


    async componentDidMount() {
        this._isMounted = true; // Компонент монтирован

        if (this.props.confirmPayToken && this.props.confirmPayService  && this.props.confirmPayService == 1) {
          this.CheckPayment();
          return
      }
        
        


        let agrfile = 'useragreement-en.html';
        if (this.getBrowserLanguage() == "ru") {
          
            agrfile = 'useragreement-ru.html';
        }
        
        this.setState({ useragreement: agrfile });

        // Динамическое добавление скрипта виджета ЮKassa
        const script = document.createElement('script');
        script.src = 'https://yookassa.ru/checkout-widget/v1/checkout-widget.js';
        script.async = true;
        
        document.body.appendChild(script);

        script.onload = async () => {

            if (! this.props.paymentOption) {
                console.error('Parameter "opt" is missing in the URL');
                return;
            }

            // Получение темы
            const topic = this.props.tinode.getMeTopic();
            this.setState({ topic: topic });

            // Создание и выполнение запроса
            const query = topic.startMetaQuery().withDesc().build();
            query.desc.inchatgpttype = "createpayment";
            query.desc.inchatgpt = this.props.paymentOption;



            try {
                const result = await topic.getMeta(query);
                console.info ("result:", result)
                
                // Проверка на наличие window.YooMoneyCheckoutWidget и успешного результата
                if (window.YooMoneyCheckoutWidget && result) {
                // Инициализация виджета ЮKassa с результатом запроса в качестве токена
                const checkout = new window.YooMoneyCheckoutWidget({
                    confirmation_token: result.desc.outchatgpt, // Используйте соответствующее поле из result для токена
                    return_url: `${window.location.origin}${window.location.pathname}` + '#?confirm=ukassa&t=' + result.desc.outchatgpt,
                    error_callback: function(error) {
                    console.log(error);
                    }
                });

                // Отображение платежной формы в контейнере
                checkout.render('payment-form');
                }
            } catch (error) {
                console.error('Error fetching meta:', error);
            }
        };
    }

    componentDidUpdate(prevProps) {
        // Проверка на изменение confirmPayService с любого значения на не пустое
      if (!prevProps.confirmPayService && this.props.confirmPayService && !this.intervalId) {
          this.startCheckingPayment();
      }
    }

    componentWillUnmount() {
      this._isMounted = false; // Компонент будет размонтирован
      // Проверяем, существует ли интервал, и останавливаем его
      if (this.intervalId) {
          clearInterval(this.intervalId);
          this.intervalId = null; // Сбрасываем идентификатор интервала для избежания утечек памяти
      }
  }
  

    startCheckingPayment = () => {
      this.props.eventToGAnalitycs("payment_start_check");
      // Установка интервала
      //this.intervalId = setInterval(this.CheckPayment, 2000); // Вызывать CheckPayment каждую секунду
      this.intervalId = setInterval(() => this.CheckPayment(), 2000);

   }

    async CheckPayment() {
        console.info ("CheckPayment")
         // Получение темы
         const topic =  this.props.tinode.getMeTopic();

         // Создание и выполнение запроса
         const query = topic.startMetaQuery().withDesc().build();
         query.desc.inchatgpttype = "checkpayment";
         query.desc.inchatgpt = this.props.confirmPayToken;
 
 
 
         try {
             const result = await topic.getMeta(query);
             //console.info ("CheckPayment result:", result)
             //console.info ("CheckPayment result.desc.outchatgpt:", result.desc.outchatgpt)
             //result.desc.outchatgpt
             //Status 1 - in progress, 2 - done, 3 - canceled, 4 error
             if (this._isMounted) { // Проверяем, что компонент еще монтирован
                if (result.desc.outchatgpt !== "1") {

                    if (result.desc.outchatgpt == "2" && result.desc.tokens && result.desc.tokens > 0) {
                        this.props.eventToGAnalitycs("purchase" , {order_price: this.props.paymentOptionSum || 0, currency: this.props.paymentOptionCurr || ''});
                        this.props.onUpdateTokensBalance(result.desc.tokens)
                    }

                    if (result.desc.outchatgpt == "3" ) {
                      this.props.eventToGAnalitycs("payment_canceled");
                      
                    }
                    if (result.desc.outchatgpt == "4" ) {
                      this.props.eventToGAnalitycs("payment_error");
                      
                    }
                    this.setState({ Result: result.desc.outchatgpt });

                    clearInterval(this.intervalId); 
                    this.intervalId = null; 
                
                }
              }
                
         } catch (error) {
             console.error('Error fetching meta:', error);
         }

    }



  render() {
    return (
    <>
    {!this.props.confirmPayService && !this.state.Result  &&
      <div>

        <div id="payment-form"></div>
        <div className="center-text">
          <FormattedMessage id="kassa_onlyrf" defaultMessage="Оплата принимается только картами выпущенными в РФ" 
            description="Оплата принимается только картами выпущенными в РФ." />
             <a href={this.state.useragreement} target="_blank" rel="noopener noreferrer"> <FormattedMessage id="useragreement" defaultMessage="Пользовательское соглашение" 
        description="Пользовательское соглашение" /></a>
         </div>
        
{/*
        <p>Данные банковской карты для оплаты в <b>тестовом магазине</b>:</p>
        <ul>
          <li>номер — <b>5555 5555 5555 4477</b></li>
          <li>срок действия — <b>01/30</b> (или другая дата, больше текущей)</li>
          <li>CVC — <b>123</b> (или три любые цифры)</li>
          <li>код для прохождения 3-D Secure — <b>123</b> (или три любые цифры)</li>
        </ul>
     
    */}

      </div>
      }

    {this.props.confirmPayService &&  ( !this.state.Result || this.state.Result == "1")  &&
      <div className="center-text margin-all-small" > 
      <FormattedMessage id="kassa_dontclose" defaultMessage=" Don't close window. Processing payment.." description=" Don't close window. Processing payment.." />

      </div>

    }

    {this.state.Result && this.state.Result == "2"   &&
      <div className="center-text margin-all-small padding-all-small"> 
        <div>
          <i className="material-icons material-icon-success">done_outline</i>
        </div>
        <div>
          <FormattedMessage id="kassa_success" defaultMessage="Платеж прошел успешно. Ваш баланс обновлен! Если у вас возникли проблемы, то напишите на contact@peacetalkchat.com" 
          description="Платеж прошел успешно. Ваш баланс обновлен! Если у вас возникли проблемы, то напишите на contact@peacetalkchat.com" />
        </div>
          
      </div>

    }

    {this.state.Result && this.state.Result == "3"  &&
      <div className="error-message margin-all-small"> 

        <div>  
            <FormattedMessage id="kassa_cancel" defaultMessage="Платеж отменен! Еслиу у вас произошло списание, то напишите об этом на contact@peacetalkchat.com" 
            description="Платеж отменен! Еслиу у вас произошло списание, то напишите об этом на contact@peacetalkchat.com" />
        </div>
      </div>

    }

    {this.state.Result && this.state.Result == "4"  &&
      <div className="error-message margin-all-small"> 
        <div>
          <i className="material-icons material-icon-error">error</i>
        </div>
        <div>  
            <FormattedMessage id="kassa_error" defaultMessage="Ошибка платежа! Еслиу у вас произошло списание, то напишите об этом на contact@peacetalkchat.com" 
            description="Ошибка платежа! Еслиу у вас произошло списание, то напишите об этом на contact@peacetalkchat.com" />
        </div>
      </div>

    }


    </>
    );
  }
}

export default YouKassaComponent;
